import { useEffect } from 'react';
import { commonEventChannel } from '../../eventChannels/common.channel';

export function useChannelAfterCrud({ refetch }: { refetch?: () => void }) {
  useEffect(() => {
    const unsubscribeSuccessAction = commonEventChannel.on(
      'onSuccessAction',
      () => {
        void refetch?.();
      },
    );

    return () => {
      unsubscribeSuccessAction();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const emitSuccessAction = () => {
    commonEventChannel.emit('onSuccessAction');
  };
  return {
    refetch,
    emitSuccessAction,
  };
}
